/**
 * URN d'une ressource de l'API ($:teiji:team:1), comme son @urn : c'est ainsi qu'une relation s'écrit (corps d'un POST
 * ou d'un PATCH), comme sur les autres projets Stonecode (platform-bundle IriConverterService). Les filtres, eux,
 * prennent l'id de la relation.
 */
export const urnOf = (resource: string, id: id | number) => `$:teiji:${resource}:${id}`;
